import Gleanin from '@/themes/gleanin'

export const theme = Gleanin

export const getTheme = () => theme
